import type { DemoKey } from './keys';

export const ru: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'Геометрия · 3D',
  'panel.figure': 'Фигура',
  'panel.dims': 'Размеры',
  'panel.style': 'Вид',
  'panel.lines': 'Особые линии',
  'style.body': 'Тело',
  'style.line': 'Линия',
  'style.cut': 'Сечение',
  'style.labels': 'Метки вершин',
  'group.face': 'Диагонали граней / образующие',
  'group.space': 'Диагонали / оси / медианы',
  'split.label': 'Сечение',
  'btn.animate': 'Анимация',
  'btn.reset': 'Сброс',
  'hint.line1': 'Перетаскивайте для вращения · Прокрутка для масштаба',
  'hint.line2': 'Нажмите на линию для выбора',
  'fig.cuboid': 'Прямоугольный параллелепипед',
  'fig.cube': 'Куб',
  'fig.triPrism': 'Треугольная призма',
  'fig.hexPrism': 'Шестиугольная призма',
  'fig.tetrahedron': 'Тетраэдр',
  'fig.squarePyramid': 'Четырёхугольная пирамида',
  'fig.cylinder': 'Цилиндр',
  'fig.cone': 'Конус',
  'fig.sphere': 'Сфера',
  'fig.frustumPyramid': 'Усечённая пирамида',
  'fig.frustumCone': 'Усечённый конус',
  'dim.length': 'длина',
  'dim.width': 'ширина',
  'dim.height': 'высота',
  'dim.side': 'сторона',
  'dim.radius': 'радиус',
  'dim.r1': 'нижний радиус',
  'dim.r2': 'верхний радиус',
  'dim.sideBase': 'сторона основания',
  'dim.sideTop': 'сторона верха',
  'info.face': 'грань',
  'info.center': 'через центр',
  'info.diagonal': 'диагональ',
  'info.axial': 'осевая диагональ',
  'info.diameter': 'диаметр',
  'info.generator': 'образующая',
  'info.axis': 'ось',
  'info.height': 'высота',
  'info.median': 'медиана',
  'info.apothem': 'апофема',
  'info.diameterBase': 'диаметр основания',
  'info.diameterTop': 'диаметр верха',
};
